if(!customElements.get('cross-sell-products')) {
  class CrossSellProducts extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }
  
    connectedCallback() {
      this.initSlider();
    }
  
    initSlider() {
      if (!this.querySelector('[data-slider]')) return;
  
      this.options = {
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
          prevEl: this.querySelector('.swiper-nav.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-nav.swiper-button-next'),
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            slidesPerGroup: 2
          },
          992: {
            slidesPerView: 3,
            slidesPerGroup: 3
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4
          }
        }
      };
  
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }
  
  customElements.define('cross-sell-products', CrossSellProducts);
}